import { render, staticRenderFns } from "./PhoneStepAccount.vue?vue&type=template&id=2730fa5f&scoped=true"
import script from "./PhoneStepAccount.vue?vue&type=script&lang=js"
export * from "./PhoneStepAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2730fa5f",
  null
  
)

export default component.exports